var e=function(){return{overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}};export{e as u};
